jQuery(function($){
    const mm = gsap.matchMedia();
    scrollToHash();

    var heroVideo = $('.hero-video');
    if(heroVideo.length > 0){
        responsiveHeroVideo(heroVideo, mm);
    }
    

    $('.play').on('click', function(){
        var video = $(this).siblings('video');
        if(video[0].paused){
            video[0].play();
            $(this).hide();
        }else{
            $this.show();
        }
    });

    mm.add("(min-width: 1090px)", () => {
        $('#mainNavigation').collapse('hide');
        menuOnHover();
        return () => {
            menuOnClick();
        }
    });

    mm.add("(min-width: 992px)", () => {

        var slider = $('.how-it-works .slider');
        if(slider.length > 0){
            cardAnimation(slider);
        }

        var stickySlider = $('.sticky-slider');
        if(stickySlider.length > 0){
            initStickySlider();
        }

    });

    //Stop scroll on modal open
    $('.modal').on('show.bs.modal', function(){
        stopScroll();
    });

    //Starts scroll on modal close and removes video and poster
    $('.modal').on('hide.bs.modal', function(){
        resumeScroll();
        RemoveVideo($(this));
    });

    //Adds video and poster to modal on img click
    var videoImagetoggler = $('.video-image-toggler');
    if(videoImagetoggler.length > 0){
        videoModal(videoImagetoggler);
    }

    //Adds video and poster to modal on btn click
    var videoBtn = $('.video-cta');
    if(videoBtn.length > 0){
        videoModal(videoBtn);
    }

    var heroVideo = $('#heroVideo');
    if(heroVideo.length > 0){
        var bullets = $('.animated');
        heroVideo.on('timeupdate', function(){
            animateVideoBullets(bullets)
        });
    }

    //Stops scroll on menu open
    $('#mainNavigation').on('show.bs.collapse', function () {
        stopScroll();
    });

    //Resumes scroll on menu close
    $('#mainNavigation').on('hide.bs.collapse', function () {
        resumeScroll();
    });

    //Adding parent class on collapse
    $('.accordion-collapse').on('show.bs.collapse', function () {
        $(this).parent().addClass('active');
    });

    //Removing parent class on collapse
    $('.accordion-collapse').on('hidden.bs.collapse', function () {
        $(this).parent().removeClass('active');
    });

    //How it works slider function
    var slider = $('.how-it-works .slider');
    if(slider.length > 0){
        mm.add("(max-width: 992px)", () => {
            slider.slick({
                arrows: false,
                dots: false,
                infinite: false,
                slidesToShow: 1.1,
                slidesToScroll: 1,
                //variableWidth: true,
                infinite: false,
                useTransform: true,
				cssEase: 'ease-out',
            });
            return () => {
                slider.slick('unslick');
            }
        });
    }

    var testimonialsSlider = $('.testimonial-slider');
    if(testimonialsSlider.length > 0){
        testimonialsSlider.slick({
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 2.2,
            slidesToScroll: 1,
            useTransform: true,
            cssEase: 'ease-out',
            responsive: [
                {
                   breakpoint: 991,
                   settings: {
                        slidesToShow: 2.2,
                   },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.2,
                    },
                 },
            ]
        });
    }

    var medicalCentersSlider = $('.medical-centers-slider');
    if(medicalCentersSlider.length > 0){
        medicalCentersSlider.slick({
            dots: false,
            autoplay: true,
            arrows: false,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
          });
    }

    titleAnimations();
    buttonAnimations();
});

document.addEventListener("DOMContentLoaded", function(e){
    initDropdown();
});

function buttonAnimations(){
    const AnimatedButtons = gsap.utils.toArray(".animated-buttons");
    //Iitial positions
    AnimatedButtons.forEach((AnBtn, i) => {
        gsap.set(AnBtn, {xPercent: -40, opacity: 0});
    });

    AnimatedButtons.forEach((AnBtn, i) => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: AnBtn,
                start: "center bottom",
            }
        });

        tl.to(AnBtn, {xPercent: 0, opacity: 1, duration: .8});
    });
}

function titleAnimations(){
    const titles = gsap.utils.toArray(".animated-title");
    //Iitial positions
    titles.forEach((title, i) => {
        gsap.set(title, {yPercent: 40, opacity: 0});
    });

    titles.forEach((title, i) => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: title,
                start: () => "top bottom-=150px",
            }
        });

        tl.to(title, {yPercent: 0, opacity: 1, duration: .8});
    });
}

//Menu dropdown opens on hover
function menuOnHover(){
    $('#menu-main-menu .dropdown, #menu-main-menu-en .dropdown').hover(function() {
        $(this).find('.nav-link').addClass('show');
        $(this).find('.dropdown-menu').addClass('show');
    }, function() {
        $(this).find('.nav-link').removeClass('show');
        $(this).find('.dropdown-menu').removeClass('show');
    });

    /*if the user clicks anywhere outside the select box,
    then close all select boxes:*/
    document.addEventListener("click", closeAllSelect);
}
//Menu dropdown opens on click
function menuOnClick(){
    $('#menu-main-menu .dropdown, #menu-main-menu-en .dropdown').unbind('mouseenter mouseleave');
}

//Removes Poster and video on modal
function RemoveVideo(modal){
    var videoElem = modal.find('video');
    if(videoElem){
        videoElem.attr('poster', '');
        videoElem[0].pause();
        videoElem[0].currentTime = 0;
        videoElem.find('source').attr('src', '');
        videoElem[0].load();
    }
}

function initStickySlider(){
    const details = gsap.utils.toArray(".scroll-text");
    const photos = gsap.utils.toArray(".sticky-images-container img");
    const icons = gsap.utils.toArray(".slide-icon-wrapper .slide-icon img");

    photos.forEach((photo, i) => {
        if(i > 0){
            gsap.set(photo, {yPercent:-101});
        }
    });

    icons.forEach((icon, i) => {
        if(i > 0){
            gsap.set(icon, {yPercent: 101});
        }
    });

    ScrollTrigger.create({
        trigger: ".sticky-slider",
        start: () => "top top",
        end: () => "bottom bottom",
        pin: ".sticky-images-wrapper",
        pinSpacing: 'margin',
        markers: false
    })

    details.forEach((detail, index)=> {
        let animation = gsap.timeline()
           .to(photos[index], {yPercent:0}, '<')
           .to(icons[index], {yPercent:0}, '<')
        ScrollTrigger.create({
            trigger: detail,
            start:"top bottom",
            end:"top top",
            animation: animation,
            scrub: true,
            markers: false
        })
    })
        
}

function responsiveHeroVideo(heroVideo, mm){
    var videoDesktop = heroVideo.find('source').attr('src');
    var desktopPoster = heroVideo.attr('poster');
    var videoMobile = heroVideo.attr('data-video');
    var mobilePoster = heroVideo.attr('data-poster');

    if(videoMobile != ''){
        mm.add("(max-width: 768px)", () => {
        
            heroVideo.attr('src', videoMobile);
            heroVideo.attr('poster', mobilePoster);
            heroVideo[0].load();

            return () => {
                heroVideo.attr('src', videoDesktop);
                heroVideo.attr('poster', desktopPoster);
                heroVideo[0].load();
            }

        });
    }
}

function videoModal(elem){
    elem.on('click', function(e){
        var poster = $(this).data('poster');
        var video = $(this).data('video');
        var modal = $('#videoModal');
        var videoElem = modal.find('video');
        videoElem.find('source').attr('src', video);
        videoElem[0].load();
        videoElem.attr('poster', poster);
    });
}

function cardAnimation(elem){
    const elems = gsap.utils.toArray(elem.find('.card-anim'));

    //Iitial positions
    elems.forEach((elem, i) => {
        if((i + 1) < (Math.round(elems.length / 2))){
            gsap.set(elem, {xPercent: 25});
        }else if((i + 1) > (Math.round(elems.length / 2))){
            gsap.set(elem, {xPercent: -25});
        }
    });

    const cardAnimationTl = gsap.timeline({
        scrollTrigger: {
            trigger: elem,
            start: "top center+=100px",
        }
    });
    elems.forEach((elem, i) => {
        cardAnimationTl.to(elem, {xPercent: 0, duration: .8}, '<');
    });
}



function animateVideoBullets(bullets){
    bullets.each(function(){
        time = $(this).data('time');
        if(heroVideo.currentTime > time){
            bullets.removeClass('show');
            $(this).addClass('show');
        }
    });
}

//lenis init
const lenis = new Lenis();
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time)=>{
    lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

function initDropdown(){
    /* Custom select dropdown for forms
    *  Add a wrapper to select with f-select class
    */
    var x, i, j, l, ll, selElmnt, a, b, c;
    /*look for any elements with the class "f-select":*/
    x = document.getElementsByClassName("f-select");
    l = x.length;
    for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function(e) {
            /*when an item is clicked, update the original select box,
            and the selected item:*/
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;
                y = this.parentNode.getElementsByClassName("same-as-selected");
                yl = y.length;
                for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                break;
            }
            }
            h.click();
        });
        b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
        });
    }
}

function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

function scrollToHash(){
    var elem = window.location.hash.substring(1);
    if(elem.length > 0){
        lenis.scrollTo('#'+elem, {offset: -200});
    }
}
var previousScrollY = 0;
function stopScroll(){
    previousScrollY = window.scrollY;
    $('body').addClass('freeze').css({
        marginTop: -previousScrollY,
    });
    lenis.stop();
}

function resumeScroll(){
    $('body').removeClass('freeze').css({
        marginTop: 0,
    });
    lenis.start();
    window.scrollTo({
        top: previousScrollY,
        left: 0,
        behavior: 'instant'
    });
}